import { render, staticRenderFns } from "./RSidebar.vue?vue&type=template&id=2ba9738a&"
import script from "./RSidebar.vue?vue&type=script&lang=js&"
export * from "./RSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RSidebar.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports